// extracted by mini-css-extract-plugin
export default {"materialResC":"index_materialResC__27CHB"};